import { render, staticRenderFns } from "./BasePagination.vue?vue&type=template&id=c701dd90&"
import script from "./BasePagination.vue?vue&type=script&lang=js&"
export * from "./BasePagination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ichigei/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c701dd90')) {
      api.createRecord('c701dd90', component.options)
    } else {
      api.reload('c701dd90', component.options)
    }
    module.hot.accept("./BasePagination.vue?vue&type=template&id=c701dd90&", function () {
      api.rerender('c701dd90', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/Bases/Pagination/BasePagination.vue"
export default component.exports